export const EmptyAddressList = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "300px",
        textAlign: "center",
      }}
    >
      <div>
        <p>No addresses available. Please add a new address.</p>
      </div>
    </div>
  );
};
